// Unlimited threshold - backend sends uint64::max (~18.4 exabytes/s)
// Using Number.MAX_SAFE_INTEGER to represent the maximum safe integer in JavaScript
// This is 2^53 - 1 = 9,007,199,254,740,991 (~9 petabytes)
// Close enough to detect backend's uint64::max without overflow issues
export const UNLIMITED_RATE_LIMIT_THRESHOLD = Number.MAX_SAFE_INTEGER;
export const DEFAULT_RATE_LIMIT_UNIT = 'MB/s';
